if (!customElements.get('search-toggle')) {
  class SearchToggle extends HTMLElement {
    constructor() {
      super();
    }

    #handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      document.dispatchEvent(new CustomEvent('search:toggle'));
    }

    connectedCallback() {
      this.addEventListener('click', this.#handleClick.bind(this));
    }
  }

  customElements.define('search-toggle', SearchToggle);
}